import { Link } from "react-router-dom";
import styled, { createGlobalStyle } from "styled-components";
import calendar from "../../assets/img/calendar.png";

const KEY = "theme";

const GlobalStyle = createGlobalStyle`
  form.bc-container.bc-card-rounded {
    padding: 30px;
    max-width: 1024px;
  }

  ::placeholder {
    color: #a9a9a9 !important;
    opacity: 1; /* Firefox */
  }

  input[type="date"]::-webkit-datetime-edit-fields-wrapperr {
    color: #a9a9a9 !important;
    opacity: 1; /* Firefox */
  }

  input[type="date"]::-webkit-calendar-picker-indicator {
    font-size: 18px;
    font-family: BC Icons !important;
    font-weight: 400;
    font-style: normal;
    content: url(${calendar});
    filter: invert(${localStorage.getItem(KEY) === "dark" ? 1 : 0});
  }

  input[type="date"]::-webkit-calendar-picker-indicator:hover {
    color: #e6e6e6;
    cursor: pointer;
  }
  
  input[type="date"]::-webkit-calendar-picker-indicator:active {
    color: blue;
  }

  input::-ms-input-placeholder {
    /* Edge 12 -18 */
    color: #e6e6e6;
  }
`;

const BcHeaderWrapper = styled.article`
  position: fixed;
`;
const BcMain = styled.main`
  padding: 15px;
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: flex-start;
  align-items: flex-start;
  align-content: flex-start;
  min-height: calc(100vh - ${(props) => (props.title ? 231 : 130)}px);
`;

const BCButton = styled.button`
  width: auto !important;
  margin: 0px 5px;
`;

const BCSelectCont = styled.div`
  margin: 10px 0 50px;
  width: 100%;
  label {
    top: -5px !important;
    font-size: 14px !important;
    font-weight: bold !important;
    text-transform: lowercase !important;
    &::first-letter {
      text-transform: capitalize !important;
    }
  }
  select ~ label[for] {
    left: 0;
    top: -30px !important;
    transition: 0;
  }
  > label[for] {
    font-size: 14px;
    line-height: 22px;
    font-family: "Open Sans";
    font-weight: 400;
    letter-spacing: 0;
    position: absolute;
    pointer-events: none;
  }

  select.bc-input:first-of-type {
    color: #A9A9A9 !important;
  }

  /* Cuando se selecciona una opción que no es el placeholder, cambia el color a negro */
  select.bc-input:not(invalid) {
      color: ${localStorage.getItem(KEY) === "dark" ? "#FFFFFF" : "#2C2A29"}; /* Color negro para las opciones reales */
  }
`;

const BCLink = styled(Link)`
  text-transform: capitalize;
`;

const BCFormList = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  align-content: center;
  width: 100%;
  column-gap: 10px;
  margin: 15px 0;
`;

const BCFormListHeader = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  align-content: center;
  width: 100%;
  column-gap: 10px;
  margin: 15px 0;
`;

const BCFormListCont = styled.div`
  display: flex;
  column-gap: 20px;
  flex-wrap: wrap;
  align-items: center;
  align-content: center;
  span {
    display: flex;
    column-gap: 5px;
    justify-content: flex-start;
    align-items: center;
    align-content: center;
    h6,
    p {
      margin: 0;
    }
  }

  .bc-form-field {
    width: auto;
    margin-bottom: 0px;
  }
`;

const BCFormOptionsList = styled.div`
  border-top: 1px solid
    ${localStorage.getItem(KEY) === "dark" ? "#97999b" : "#353537"};
  padding-top: 15px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  align-content: center;
  width: 100%;
  column-gap: 10px;
  margin: 15px 0;
`;

const BCFormOptionsHeader = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 5px 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  align-content: center;
  width: 100%;
  row-gap: 10px;
`;

const BCFormOptionsListCont = styled.div`
  display: flex;
  column-gap: 20px;
  flex-wrap: wrap;
  align-items: center;
  align-content: center;
  width: 100%;
  span {
    display: flex;
    column-gap: 5px;
    justify-content: flex-start;
    align-items: center;
    align-content: center;
    h6,
    p {
      margin: 0;
    }
  }

  .bc-form-field {
    width: 45%;
    margin-bottom: 0px;
  }
`;

const BCFieldset = styled.fieldset`
  border-radius: 10px;
  border-color: #f5f5f5;
  padding: 15px;
  margin: 30px 0;
  legend {
    padding: 0 15px;
  }
`;

const BCInputCont = styled.div`
  margin-bottom: 50px;
  > label[for] {
    top: -30px !important;
    font-weight: bold !important;
    text-transform: lowercase !important;
    &::first-letter {
      text-transform: capitalize !important;
    }
  }
`;

const BCContainerTag = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const BCTagCountry = styled.span`
  font-size: 12px;
  padding: 5px 10px;
  border-radius: 15px;
  background-color: #cccccc;
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-content: center;
  margin: 10px;
  min-width: 100px;
  height: 30px;
  .btn-clear {
    background-color: transparent;
    border: none;
    font-size: 12px;
    transform: scale(0.7);
    cursor: pointer;
    &:hover {
      color: #ffffff;
    }
  }
`;

const FieldGlobal = `
  height: 40px !important;
  padding: 0 10px !important;
`;

const BCInput = styled.input`
  ${FieldGlobal}
`;

const BCSelect = styled.select`
  ${FieldGlobal}
`;

const BCTextArea = styled.textarea`
  padding: 10px !important;
`;

const BCArrayFieldsCont = styled.div`
  border-radius: 10px;
  border: solid 2px #f5f5f5;
  border-style: groove;
  padding: 15px;
  margin: 30px 0;
`;

const BCFieldsCont = styled.div`
  margin: 15px 0;
  padding: 15px;
  border: 1px solid #b8b8b8;
  border-radius: 10px;
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  align-content: center;
`;

const BCFieldItem = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-content: center;
  width: 100%;
  max-height: 250px;
  margin: 10px;
  padding: 10px;
  border: 1px solid #b8b8b8;
  box-shadow: 2px 2px 4px rgba($color: #000000, $alpha: 0.5);
  border-radius: 10px;
  overflow: hidden;
  text-align: center;
  @media (min-width: 1280px) {
    text-align: left;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
  }
`;

const BCFieldsDelCont = styled.div`
  display: flex;
  justify-content: space-around;
  width: 100%;
  height: 100%;
  margin-top: 15px;
  @media (min-width: 1280px) {
    width: auto;
    gap: 10px;
  }
`;

const LetterAvatar = styled.div`
  width: 28px;
  height: 28px;
  background-color: #fdda24;
  margin-left: -2px;
  margin-top: -2px;
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  border-radius: 50%;
  p {
    font-family: "CIB Sans bold";
    color: #292929;
    font-weight: bold;
    font-size: 25px;
    text-transform: uppercase;
  }
`;

const BCInputFileTitleIcon = styled.div`
  width: 70%;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 25px;
`;

const BCPageRedirect = styled.div`
  margin: auto;
  padding: 30px;
  text-align: center;
  min-height: calc(100vh - ${(props) => (props.title ? 231 : 160)}px);
  p {
    margin-bottom: 10px;
  }
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
  flex-direction: column;
  row-gap: 10px;
`;

type WidthProps = {
  widthOption: "small" | "medium" | "large";
  iconOption: "default" | "success" | "error" | "info" | "warning";
};

const BcModalActive = styled.article<WidthProps>`
  opacity: 1;
  animation: fade-in 350ms;
  overflow-x: clip;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  z-index: 1072;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: auto;
  pointer-events: auto;
  background-color: rgba(44, 42, 31, 0.8);
  .bc-modal-container {
    width: ${(props) => {
      switch (props.widthOption) {
        case "small":
          return "400px";
        case "medium":
          return "600px";
        case "large":
          return "700px";
        default:
          return "400px";
      }
    }};
    height: auto;
    position: relative;
    padding: 16px 24px 32px;
    margin: auto;
    background: ${localStorage.getItem(KEY) === "dark" ? "#353537" : "#fff"};
    text-align: justify;
    box-shadow: 0 10px 16px 0 rgba(44, 42, 41, 0.08);
    border-radius: 16px;
    .bc-modal-close-button-container {
      display: flex;
      justify-content: flex-end;
    }
    .bc-modal-close-button {
      border-radius: 50%;
      border: none;
      background: transparent;
      text-align: right;
      pointer-events: auto;
      cursor: pointer;
      display: inherit;
      color: ${localStorage.getItem(KEY) === "dark" ? "#FFF" : "#2C2A29"};
      position: static;
    }
    .bc-modal-icon-container {
      div {
        background-color: ${(props) => {
          switch (props.iconOption) {
            case "success":
              return "#00C389";
            case "error":
              return "#FF7F41";
            case "warning":
              return "#FDDA24";
            case "info":
              return "#59CBE8";
            default:
              return "transparent";
          }
        }};
        height: 48px;
        width: 48px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        margin-bottom: 15px;
      }
    }
  }
`;

const ContainerReko = styled.div`
  margin: 20px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  @media (min-width: 1024px) {
    flex-direction: row;
  }
  .img-cont {
    padding: 15px;
    width: 100%;
    @media (min-width: 1024px) {
      width: 50%;
    }
    img {
      width: 100%;
    }
  }
  .data-cont {
    margin-left: 10px;
    padding: 15px;
    width: 100%;
    @media (min-width: 1024px) {
      width: 50%;
    }
    .label-cont {
      margin: 10px 0;
      border-bottom: 1px solid
        ${localStorage.getItem(KEY) === "dark" ? "#97999b" : "#353537"};
      padding-bottom: 10px;
      display: flex;
      justify-content: space-between;
      strong {
        font-family: "CIB Sans Bold", sans-serif;
      }
    }
    .img-qua {
      margin: 10px 0;
      border-bottom: 1px solid
        ${localStorage.getItem(KEY) === "dark" ? "#97999b" : "#353537"};
      padding-bottom: 10px;
      display: flex;
      justify-content: space-between;
      strong {
        font-family: "CIB Sans Bold", sans-serif;
      }
    }
    .circle-color {
      width: 30px;
      height: 30px;
      border-radius: 50%;
    }
  }
`;

const TypeBrief = styled.section`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 10px;
  width: 100%;

  .bc-card-rounded {
    text-decoration: none;
    color: ${localStorage.getItem(KEY) === "dark" ? "#FFF" : "#2C2A29"};
  }
  @media (min-width: 1024px) {
    flex-direction: row;
  }
`;



export {
  GlobalStyle,
  BcHeaderWrapper,
  BcMain,
  BCButton,
  BCSelectCont,
  BCLink,
  BCFormListHeader,
  BCFormList,
  BCFormListCont,
  BCFormOptionsList,
  BCFormOptionsHeader,
  BCFormOptionsListCont,
  BCFieldset,
  BCContainerTag,
  BCTagCountry,
  BCInputCont,
  BCInput,
  BCSelect,
  BCTextArea,
  BCArrayFieldsCont,
  BCFieldsCont,
  BCFieldItem,
  BCFieldsDelCont,
  LetterAvatar,
  BCInputFileTitleIcon,
  BCPageRedirect,
  BcModalActive,
  ContainerReko,
  TypeBrief,
};
